/* ============================================================
   VICIT LEO — theme behaviour
   Prefixed vl.js so it can never collide with Horizon's theme.js.
   Every initialiser is idempotent and scoped to a root element, so
   the theme editor's section:load event can re-run it safely.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.VLConfig || {};
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function once(el, key) {
    if (!el) return false;
    var flag = 'vlInit' + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = '1';
    return true;
  }

  var fmt = null;

  /* ==========================================================
     Toast
     ========================================================== */
  var toastTimer;

  /* ==========================================================
     Overlays — drawers, modal, scrim, focus trap
     ========================================================== */
  var openPanel = null, lastFocus = null;

  /* ==========================================================
     Header. Floats over a hero image, then resolves to a solid
     bar once the page moves. Also publishes the announcement
     bar's height, which the floating header offsets against.

  /* ==========================================================
     Announcement bar
     ========================================================== */
  function initAnnounce(root) {
    $$('[data-vl-announce]', root).forEach(function (host) {
      if (!once(host, 'Ann')) return;
      var msgs = $$('.announce__msg', host);
      if (msgs.length < 2) return;
      var i = 0, timer;
      var paused = REDUCED;
      var wait = parseInt(host.getAttribute('data-interval'), 10) || 5000;

      function show(next) {
        msgs[i].classList.remove('is-on');
        msgs[i].hidden = true;
        i = (next + msgs.length) % msgs.length;
        msgs[i].hidden = false;
        msgs[i].classList.add('is-on');
      }
      function auto() {
        if (paused) return;
        clearInterval(timer);
        timer = setInterval(function () { show(i + 1); }, wait);
      }
      var bar = host.closest('.announce') || host;
      $$('[data-ann]', bar).forEach(function (btn) {
        btn.addEventListener('click', function () {
          show(i + (btn.getAttribute('data-ann') === 'next' ? 1 : -1));
          auto();
        });
      });
      var toggle = $('[data-ann-toggle]', bar);
      if (toggle) {
        if (paused) {
          toggle.setAttribute('aria-label', 'Play announcements');
          $('[data-ann-pause]', toggle).hidden = true;
          $('[data-ann-play]', toggle).hidden = false;
        }
        toggle.addEventListener('click', function () {
          paused = !paused;
          toggle.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
          var pauseIcon = $('[data-ann-pause]', toggle);
          var playIcon = $('[data-ann-play]', toggle);
          if (pauseIcon) pauseIcon.hidden = paused;
          if (playIcon) playIcon.hidden = !paused;
          if (paused) clearInterval(timer); else auto();
        });
      }
      bar.addEventListener('focusin', function () { clearInterval(timer); });
      bar.addEventListener('focusout', auto);
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', auto);
      auto();
    });
  }

  /* ==========================================================
     Megamenu — hover on pointer devices, click and keyboard always

  /* ==========================================================
     Hero slideshow
     ========================================================== */
  function initHero(root) {
    $$('[data-vl-hero]', root).forEach(function (vp) {
      if (!once(vp, 'Hero')) return;
      var slides = $$('.hero__slide', vp);
      if (!slides.length) return;

      var dots = $('[data-vl-hero-dots]', vp);
      var i = 0, timer;
      var wait = parseInt(vp.getAttribute('data-interval'), 10) || 7000;
      var autoOn = vp.getAttribute('data-autoplay') === 'true' && slides.length > 1;
      var paused = REDUCED;
      var buttons = [];

      if (dots && slides.length > 1) {
        slides.forEach(function (s, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'hero__dot' + (n === 0 ? ' is-on' : '');
          b.setAttribute('aria-label', 'Go to slide ' + (n + 1));
          if (n === 0) b.setAttribute('aria-current', 'true');
          b.addEventListener('click', function () { go(n); auto(); });
          dots.appendChild(b);
        });
        buttons = $$('.hero__dot', dots);
      }

      function playing(slide) { return $('video', slide); }

      function go(n) {
        slides[i].classList.remove('is-on');
        var prevVid = playing(slides[i]);
        if (prevVid) { try { prevVid.pause(); } catch (e) {} }
        if (buttons[i]) {
          buttons[i].classList.remove('is-on');
          buttons[i].removeAttribute('aria-current');
        }
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-on');
        if (buttons[i]) {
          buttons[i].classList.add('is-on');
          buttons[i].setAttribute('aria-current', 'true');
        }
        var vid = playing(slides[i]);
        if (vid && !REDUCED) { vid.play().catch(function () {}); }
        syncVolButton();
      }

      function auto() {
        if (paused || !autoOn) return;
        clearInterval(timer);
        timer = setInterval(function () { go(i + 1); }, wait);
      }

      var toggle = $('[data-vl-hero-toggle]', vp);
      function syncAutoToggle() {
        if (!toggle) return;
        toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        var pauseIcon = $('[data-vl-hero-pause]', toggle);
        var playIcon = $('[data-vl-hero-play]', toggle);
        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
      }
      if (toggle) {
        toggle.addEventListener('click', function () {
          paused = !paused;
          if (paused) clearInterval(timer); else auto();
          syncAutoToggle();
        });
        syncAutoToggle();
      }

      $$('[data-vl-hero-nav]', vp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          go(i + (btn.getAttribute('data-vl-hero-nav') === 'next' ? 1 : -1));
          auto();
        });
      });

      vp.addEventListener('mouseenter', function () { clearInterval(timer); });
      vp.addEventListener('mouseleave', auto);
      vp.addEventListener('focusin', function () { clearInterval(timer); });
      vp.addEventListener('focusout', auto);

      // sound control only matters while a video slide is showing
      var vol = $('[data-vl-hero-vol]', vp);
      function syncVolButton() {
        if (!vol) return;
        var vid = playing(slides[i]);
        vol.hidden = !vid;
        if (vid) {
          vol.setAttribute('aria-label', vid.muted ? 'Unmute video' : 'Mute video');
        }
      }
      if (vol) {
        vol.addEventListener('click', function () {
          var vid = playing(slides[i]);
          if (!vid) return;
          vid.muted = !vid.muted;
          if (!vid.muted) vid.play().catch(function () {});
          syncVolButton();
        });
      }

      var firstVid = playing(slides[0]);
      if (firstVid && !REDUCED) firstVid.play().catch(function () {});
      syncVolButton();
      auto();
    });
  }

  function initBandVideo(root) {
    $$('.videoband__frame', root).forEach(function (frame) {
      if (!once(frame, 'BandVideo')) return;
      var vid = $('video', frame);
      var playBtn = $('[data-vl-band-play]', frame);
      var volBtn = $('[data-vl-band-vol]', frame);
      if (!vid) return;
      var userPaused = REDUCED;

      function syncPlay() {
        if (!playBtn) return;
        playBtn.setAttribute('aria-label', vid.paused ? 'Play video' : 'Pause video');
        var playIcon = $('[data-vl-play-icon]', playBtn);
        var pauseIcon = $('[data-vl-pause-icon]', playBtn);
        if (playIcon) playIcon.hidden = !vid.paused;
        if (pauseIcon) pauseIcon.hidden = vid.paused;
      }

      function syncVolume() {
        if (!volBtn) return;
        volBtn.setAttribute('aria-label', vid.muted ? 'Unmute video' : 'Mute video');
        var mutedIcon = $('[data-vl-muted-icon]', volBtn);
        var soundIcon = $('[data-vl-sound-icon]', volBtn);
        if (mutedIcon) mutedIcon.hidden = !vid.muted;
        if (soundIcon) soundIcon.hidden = vid.muted;
      }

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (vid.paused) {
            userPaused = false;
            vid.play().catch(function () {});
          } else {
            userPaused = true;
            vid.pause();
          }
        });
      }
      if (volBtn) {
        volBtn.addEventListener('click', function () {
          vid.muted = !vid.muted;
          if (!vid.muted) vid.play().catch(function () {});
          syncVolume();
        });
      }
      vid.addEventListener('play', syncPlay);
      vid.addEventListener('pause', syncPlay);
      syncPlay();
      syncVolume();

      if (!REDUCED && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !userPaused) {
              vid.play().catch(function () {});
            } else if (!entry.isIntersecting) {
              vid.pause();
            }
          });
        }, { threshold: .35 });
        observer.observe(frame);
      } else if (!REDUCED) {
        vid.play().catch(function () {});
      }
    });
  }

  /* ==========================================================
     Promises carousel dots (narrow screens)
     ========================================================== */
  function initPromises(root) {
    $$('[data-vl-promises]', root).forEach(function (grid) {
      if (!once(grid, 'Promises')) return;
      var section = grid.closest('.promises') || grid.parentNode;
      var dots = $('[data-vl-promises-dots]', section);
      if (!dots) return;
      var cells = $$('.promise', grid);

      cells.forEach(function (cell, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = n === 0 ? 'is-on' : '';
        b.setAttribute('aria-label', 'Show benefit ' + (n + 1) + ' of ' + cells.length);
        if (n === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () {
          grid.scrollTo({ left: cell.offsetLeft, behavior: REDUCED ? 'auto' : 'smooth' });
        });
        dots.appendChild(b);
      });
      var buttons = $$('button', dots);

      grid.addEventListener('scroll', function () {
        var n = Math.round(grid.scrollLeft / Math.max(grid.clientWidth, 1));
        buttons.forEach(function (b, k) {
          b.classList.toggle('is-on', k === n);
          if (k === n) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      }, { passive: true });
    });
  }

  /* ==========================================================
     Locale dropdowns
     ========================================================== */
  function initLocales(root) {
    $$('[data-vl-locale]', root).forEach(function (host) {
      if (!once(host, 'Locale')) return;
      var btn = $('[data-vl-locale-btn]', host);
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = host.classList.contains('is-open');
        $$('[data-vl-locale]').forEach(function (h) {
          h.classList.remove('is-open');
          var hb = $('[data-vl-locale-btn]', h);
          if (hb) hb.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          host.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (!once(document.body, 'LocaleOutside')) return;
    document.addEventListener('click', function (e) {
      $$('[data-vl-locale]').forEach(function (h) {
        if (!h.contains(e.target)) {
          h.classList.remove('is-open');
          var hb = $('[data-vl-locale-btn]', h);
          if (hb) hb.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ==========================================================
     Predictive search

  /* ==========================================================
     Boot
     ========================================================== */
  function initAll(root) {
    root = root || document;
    initAnnounce(root);
    initHero(root);
    initBandVideo(root);
    initPromises(root);
    initLocales(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // theme editor: re-initialise whatever section was just re-rendered
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
